import axios, { AxiosError } from 'axios';
import { Api } from '../../axios-config';

export interface IListagemProducaoresumo {
  idfun: string;
  datalan: Date;
  idproducao: string;
  descricao: string;
  pivot: string;
  qtd: number;
  meta: number;
  vladicional: number;
  vlatividade: number;
  total: number;
}

export interface IListagemValesgrafico {
  mes: number,
  periodo: string,
  total: number,
}

type TotalCount = {
  data: IListagemProducaoresumo[];
  totalCount: number;
}

interface ErrorResponse {
  error: {
    default: string;
  };
}

const getAll = async (idfun: string, periodo: string): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/producaoresumo?idfun=${idfun}&periodo=${periodo}`;
    const { data } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(0),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

export const ProducaoresumoServer = {
  getAll
};